import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {DcpCheckoutOrderSummaryModule} from '@app/checkout/dcp-checkout-order-summary/dcp-checkout-order-summary.module';
import {DcpCheckoutPlaceOrderModule} from '@app/checkout/dcp-checkout-place-order/dcp-checkout-place-order.module';
import {DcpCartCouponModule} from '@app/shared/coupon/dcp-cart-coupon.module';
import {I18nModule, UrlModule} from '@spartacus/core';
import {SummaryComponent} from './summary.component';

import {GroupSkipDirective} from '@dcp/accessibility';
import '@sapudex/web-components/dist/Tile.js';

@NgModule({
  imports: [
    CommonModule,
    DcpCartCouponModule,
    DcpCheckoutOrderSummaryModule,
    DcpCheckoutPlaceOrderModule,
    UrlModule,
    RouterModule,
    I18nModule,
    GroupSkipDirective,
    SummaryComponent,
  ],
  exports: [SummaryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SummaryModule {}
